'use strict';

var _ = require('lodash');

module.exports = {
  /**
   * Method used to track the custom events.
   *
   * @param {string} name - Event name.
   * @param {object=} data - Can contain extra data related to the event.
   */
  event: function event(name, data) {
    window.dataLayer.push(_.assign({ event: name }, data));
  },

  /**
   * Inserts the Google Tag Manager init script.
   *
   * @param {string} containerId - Google tag manager container id.
   */
  initialise: function initialise(containerId) {
    // Initialise empty data layer
    window.dataLayer = [];

    /*eslint-disable */
    (function (w, d, s, l, i) {
      w[l] = w[l] || [];w[l].push({
        'gtm.start': new Date().getTime(), event: 'gtm.js'
      });var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != 'dataLayer' ? '&l=' + l : '';j.async = true;j.src = '//www.googletagmanager.com/gtm.js?id=' + i + dl;f.parentNode.insertBefore(j, f);
      w.gtag = w.gtag || function gtag() {
        w[l].push(arguments);
      };
    })(window, document, 'script', 'dataLayer', containerId);
    /* eslint-enable */
  },

  /**
   * Method used to track the GA4 related custom events.
   *
   * @param {string} name - Event name.
   * @param {object=} data - Can contain extra data related to the event.
   */
  submit: function submit(name) {
    var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    window.gtag('event', name, data);
  }
};